const Methods = {
    EVENTS: '31',
    DISCIPLINES: '378',
    ATTENDANCE: '314',
    GETCOMPLAINTS: '357',
    GETAPPOINTMENTS:'401',
    COMPLAINTTYPE: '355',
    SUBMITCOMPLAINT: '356',
    NOTIFICATIONS: '39',
    NOTIFICATIONSCOUNT: '310',
    TIMETABLE: '317',
    HOMEPAGE: '318',
    RESULTS: '316',
    SONET: '379',
    ARJUNA: '382',
    PROFILE: '32',
    PERFORMANCE: '315',
    LIVECLASSROOM: '321',
    SUBMITAPPOINTMENT:'400',
    SUBMITPARTICIPATION:'403',
    CHANGEPASSWORD: '999',
    GETSTUDENTDIARY:'402',
    SUBMITGROUPCHANGE:'404',
    global_url: 'https://ksjc.teleuniv.in'
};

export default Methods;

// kmit ==> 'http://teleuniv.in'
// ngit ==> 'https://teleuniv.net.in'
// kmec ==> 'http://teleuniv.net.in:81'
// kmce ==> 'http://teleuniv.net.in:82'
// ksjc ==> 'https://ksjc.teleuniv.in'
